"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBrandHostnameWhitelist = exports.verifyInitOrigin = void 0;
const global_utils_1 = require("../global-utils");
const launch_utils_config_1 = __importDefault(require("./launch-utils.config"));
const DEFAULT_THEME = "nib";
/**
 * Verify origin against the following criteria:
 * - Matching protocol (e.g. `https`)
 *
 * And ANY ONE of the following:
 * - URL indicates `localhost` (for local development)
 * - Hostname is the same as current hostname
 * - Hostname is on the whitelist of external hostnames
 */
const verifyInitOrigin = function (origin) {
  let themeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THEME;
  const theme = themeName;
  const protocolRegex = new RegExp(`^${window.location.protocol}//`);
  const hostRegex = new RegExp(`${window.location.hostname}$`);
  const testEnvRegex = getTestEnvRegex(theme);
  const isSameProtocol = protocolRegex.test(origin);
  const isSameHost = hostRegex.test(origin);
  const isTestEnv = testEnvRegex.test(window.origin);
  const isLocal = (0, global_utils_1.isLocalhost)(origin);
  const hostnameWhitelist = (0, exports.getBrandHostnameWhitelist)(theme);
  const isWhitelistedHost = hostnameWhitelist.some(host => host.test(origin));
  const isAcceptableHost = isSameHost || isWhitelistedHost;
  return isLocal || isTestEnv || isSameProtocol && isAcceptableHost;
};
exports.verifyInitOrigin = verifyInitOrigin;
const getBrandHostnameWhitelist = function () {
  let theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_THEME;
  const brandHostnameWhitelists = {
    gu: launch_utils_config_1.default.GU_HOSTNAME_WHITELIST,
    nib: launch_utils_config_1.default.NIB_HOSTNAME_WHITELIST
  };
  return brandHostnameWhitelists === null || brandHostnameWhitelists === void 0 ? void 0 : brandHostnameWhitelists[theme];
};
exports.getBrandHostnameWhitelist = getBrandHostnameWhitelist;
const getTestEnvRegex = function () {
  let theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_THEME;
  const nibTestEnvRegex = /(.+\.)?nib-cf-test\.com$/;
  const guTestEnvRegex = /(.+\.)?guhealth-test\.com$/;
  const testHosts = {
    gu: guTestEnvRegex,
    nib: nibTestEnvRegex
  };
  return testHosts[theme];
};